<div class="container-fluid">
  <div class="row py-3">
    <div class="col">
      <h2>Admin</h2>
      <hr />
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-6">
      <h5>Deactivate Site:</h5>
      <ul class="vive-blue_list">
        <li>
          Deactivate this site if you are no longer actively managing the
          association or you wish not to include it in VIVE Compliance
          activities.
        </li>
        <li>You may reactivate the site at a later date.</li>
        <li>
          Contact VIVE if you would like to remove this site from your database
          completely. All previous data entered and activities will be archived
          by VIVE.
        </li>
      </ul>
    </div>

    @if (Site) {
      <div class="col-12 col-lg-6">
        @if (Site.status === 'Active') {
          <button class="btn btn-danger my-3" (click)="deActivateSite()">
            Deactivate site
          </button>
        }
        @if (Site.status === 'Deactivated') {
          <button class="btn btn-primary my-3" (click)="activateSite()">
            Activate site
          </button>
        }
      </div>
    }
  </div>
</div>
